import apis from '../apis/apis'

const importVanBangProcessor = {}
const controllerName = 'ImportVanBang'

importVanBangProcessor.getByKhoaThi = async ({ khoaThiId, skip, take, state, name }) => {
  const rs = await apis[controllerName].GetImportedByKhoaThiId({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&state=${state || 0}&name=${name || ''}`,
  })
  return rs.isSuccess ? rs.data : []
}

importVanBangProcessor.deleteImport = async (id) => {
  const rs = await apis[controllerName].DeleteImport({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

importVanBangProcessor.chuyenChinhThuc = async (id) => {
  const rs = await apis[controllerName].ChuyenChinhThuc({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

importVanBangProcessor.import = async (data, id) => {
  const rs = await apis[controllerName].Import({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
    data,
  })
  return rs
}

importVanBangProcessor.getAll = async () => {
  const rs = await apis[controllerName].GetAll({})
  return rs.isSuccess ? rs.data.values : []
}

importVanBangProcessor.upsert = async (data) => {
  let rs
  if (data.id) {
    rs = await apis[controllerName].Update({ method: 'post', responseType: 'text', data })
  } else {
    rs = await apis[controllerName].Create({ method: 'post', responseType: 'text', data })
  }
  return rs
}

importVanBangProcessor.checKHaveInvalid = async (id) => {
  const rs = await apis[controllerName].ChecKHaveInvalid({
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

importVanBangProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

export default importVanBangProcessor
